<ng-container *ngIf="paymentMethod && firebaseAuthToken; else noPaymentMethod">
  <div class="min-h-dvh w-full max-w-[636px]">
    <div class="flex flex-col w-full h-full"> 
      <section class="px-6">
        <app-sign-in-header [cmsLabels$]="cmsLabels$" [languageList]="languageList" [displayBackButton]="displayBackButton()" (backButtonClickEvent)="handleBackButton()"></app-sign-in-header>
      </section>
      <section class="h-full px-6">
        <div [ngClass]="{'hidden': currentStep !== steps['digitalPaymentLanding'], 'h-full': currentStep === steps['digitalPaymentLanding']}">
        </div>
        <div *ngIf="paymentMethod === 'bank'" [ngClass]="{'hidden': currentStep !== steps['bankAccount'], 'h-full': currentStep === steps['bankAccount']}">
          <app-bank-account
              [labels]="(cmsLabels$ | async)?.labels"
              [firebaseAuthToken]="firebaseAuthToken"
              [paymentMethod]="paymentMethod"
              [bankMode]="bankMode"
              (updateBankModeEvent)="updateBankMode($event)"
              (bankSendValidateEvent)="initiateSendValidate()"
          ></app-bank-account>
        </div>
        <div *ngIf="paymentMethod === 'debit'" [ngClass]="{'hidden': currentStep !== steps['paymentPlatform'], 'h-full': currentStep === steps['paymentPlatform']}">
          <!-- Todo: Tim: #may6 - do we need firebase AuthToken in here?? -->
          <app-payment-platform-sdk
              [labels]="(cmsLabels$ | async)?.labels"
              [launchPaymentPlatformSdk]="launchPaymentPlatformSdk"
              (paymentPlatformSdkCompleteEvent)="paymentPlatformCompletion($event)"
          ></app-payment-platform-sdk>
        </div>
        <div [ngClass]="{'hidden': currentStep !== steps['gffp'], 'h-full': currentStep === steps['gffp']}">
            <app-gffp
              [enumerations]="enumerationsResponse$ | async"
              [countries]="countries$ | async"
              [labels]="(cmsLabels$ | async)?.labels"
              [locale]="locale"
              [fieldNames]="(gffpFieldNames$ | async) || []"
              [sendValResponseError]="sendValResponseError$ | async"
              (submitted)="onGffpSubmit($event)"
            ></app-gffp>
        </div>
        <div [ngClass]="{'hidden': currentStep !== steps['summary'], 'h-full': currentStep === steps['summary']}">
          <app-summary
            *ngIf="summaryData$ | async as summaryData"
            [flow]="operation"
            [labels]="(cmsLabels$ | async)?.labels"
            [wallet]="walletProvider"
            [locale]="locale"
            [isWalletFeeEnabled]="isWalletFeeEnabled$ | async"
            [exchangeRate]="exchangeRate"
            [summaryData]="summaryData"
            [stateOptions]="subdivisionOptions"
            [selectedLocation]="selectedLocation$ | async"
            [hideUserInfo]="true"
            [paymentMethod]="paymentMethod"
            (next)="onCommit()"
          ></app-summary>
        </div>
        <div [ngClass]="{'hidden': currentStep !== steps['confirmation'], 'h-full': currentStep === steps['confirmation']}">
            <app-confirmation
              *ngIf="
                commitResponse?.sep24TransactionResponse &&
                (summaryData$ | async) as summaryData
              "
              [commitResponse]="commitResponse"
              [labels]="(cmsLabels$ | async)?.labels"
              [walletProvider]="walletProvider"
              [isformFreeLocation]="false"
              [isWalletFeeEnabled]="(isWalletFeeEnabled$ | async)"
              [flow]="operation"
              [google]="google"
              [exchangeRate]="exchangeRate"
              [summaryData]="summaryData"
              [stateOptions]="subdivisionOptions"
              [selectedLocation]="selectedLocation$ | async"
              [locale]="locale"
              [hideUserInfo]="true"
              [paymentMethod]="paymentMethod"
            ></app-confirmation>
        </div>
      </section>
    </div>
  </div>
</ng-container>
<ng-template #noPaymentMethod>
  <p>Todo: something has gone wrong, no payment method is selected</p>
</ng-template>